const toRadians = (degrees) => {
  return (degrees * Math.PI) / 180;
};

export const toXYZTilesURL = (latitude, longitude, zoom) => {
  // const zoom = 18;
  const n = Math.pow(2, zoom);
  const xtile = Math.floor(((longitude + 180) / 360) * n);
  const ytile = Math.floor(
    ((1 -
      Math.log(
        Math.tan(toRadians(latitude)) + 1 / Math.cos(toRadians(latitude))
      ) /
        Math.PI) /
      2) *
      n
  );
  return `https://wms.openstreetmap.fr/tms/1.0.0/montauban_2020/${zoom}/${xtile}/${ytile}.jpeg`;
};
